import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import React, { FC } from "react";
import { SalifySocialIcon } from "src/lib/components/ui/icon/social-icon";
import { SalifyLinkV2 } from "src/lib/components/ui/link/link";
import { SocialGroupInterface } from "src/lib/utils/interfaces";

interface HaiAnhHeaderTopBarProps {
  name: string | undefined;
  topBarInfoText: string | undefined;
  socialGroup: Array<SocialGroupInterface> | undefined;
  socialSpacing?: number;
  showSearch?: boolean;
  searchPlaceholder?: string;
  nameStyle?: {
    fontSize?: string;
    fontWeight?: number;
    color?: string;
    fontFamily?: string;
  };
}

export const HaiAnhHeaderTopBar: FC<HaiAnhHeaderTopBarProps> = ({
  name,
  topBarInfoText,
  socialGroup,
  socialSpacing = 1,
  showSearch = false,
  searchPlaceholder = "Nhập tên sản phẩm cần tìm",
  nameStyle,
}) => {
  const theme = useTheme();

  return (
    <Box
      py={{ laptop: 1, mobile: 0.5 }}
      bgcolor="primary.main"
      color="primary.contrastText"
      display="block"
    >
      {(name || topBarInfoText || !!socialGroup?.length) && (
        <Container
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: { laptop: "row", mobile: "column" },
            gap: { laptop: 0, mobile: 0.5 },
          }}
        >
          {name && (
            <Typography
              fontWeight={nameStyle?.fontWeight || 600}
              sx={{
                fontSize: {
                  laptop: nameStyle?.fontSize || "inherit",
                  mobile: "14px",
                },
                color: nameStyle?.color || "text.black",
                fontFamily: nameStyle?.fontFamily || "inherit",
                textAlign: { laptop: "left", mobile: "center" },
              }}
            >
              {name}
            </Typography>
          )}

          {(topBarInfoText || !!socialGroup?.length) && (
            <Stack
              direction={{ laptop: "row", mobile: "row" }}
              alignItems="center"
              divider={
                <Box
                  mx={1}
                  width="1px"
                  height={16}
                  sx={{
                    backgroundColor: "primary.contrastText",
                    display: { laptop: "block", mobile: "none" },
                  }}
                />
              }
            >
              {topBarInfoText && (
                <Typography
                  sx={{
                    color: "text.grey",
                    fontSize: { laptop: "inherit", mobile: "12px" },
                    textAlign: { laptop: "left", mobile: "center" },
                  }}
                >
                  {topBarInfoText}
                </Typography>
              )}

              {!!socialGroup?.length && (
                <Stack
                  direction="row"
                  spacing={socialSpacing}
                  sx={{ display: { laptop: "flex", mobile: "none" } }}
                >
                  {socialGroup.map((item, index) => {
                    if (!item.url) return null;

                    return (
                      <SalifyLinkV2 href={item.url} key={index}>
                        <SalifySocialIcon type={item.type} color="primary.contrastText" size={20} />
                      </SalifyLinkV2>
                    );
                  })}
                </Stack>
              )}
            </Stack>
          )}
        </Container>
      )}
    </Box>
  );
};
